import {useTranslation} from "react-i18next";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from "@mui/icons-material/Close";
import * as React from "react";
import {
    UserLegalEntitiesOrDealersInputGroup
} from "../../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import dayjs from "dayjs";
import TaxConfigurationDetail from "../../../component/TaxConfiguration/TaxConfigurationDetail";
import {useRecoilState} from "recoil";
import {DEPOSIT_CODES_LIST} from "../../../service/SalesMarketingRecoil";
import {useEffect} from "react";
import {useProductCodeActions} from "../../../service/useProductCodeActions";

const ProductCodeDetailModal = (props: any) => {
    const {t} = useTranslation(['salesmarketing']);
    const {productCode} = props;
    const theme = useTheme();
    const [depositList] = useRecoilState(DEPOSIT_CODES_LIST);
    const {getPreAuthorizationList} = useProductCodeActions();

    useEffect(()=>{
        if(productCode && productCode.dealerId && productCode.tenantId){
            getPreAuthorizationList(productCode.tenantId, productCode.dealerId);
        }
    },[props.open]);

    return (productCode &&
        <Dialog scroll={"paper"} maxWidth={"lg"} disableEscapeKeyDown fullWidth={true} open={props.open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {t('salesmarketing:product.details.title')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        props.handleClose();
                    }}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRoundedIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container rowSpacing={3} columnSpacing={3}>
                    <UserLegalEntitiesOrDealersInputGroup disabled={true} dealerId={productCode.dealerId}
                                                          tenantId={productCode.tenantId}/>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.statusField')}
                            InputProps={{
                                readOnly: true
                            }}
                            value={productCode.status ? productCode.status : '--'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.productCodeField')}
                            InputProps={{
                                readOnly: true
                            }}
                            value={productCode.productCode ? productCode.productCode : '--'}
                        />
                    </Grid>
                    <Grid item xs={6}/>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.nameField')}
                            InputProps={{readOnly: true}}
                            value={productCode.name ? productCode.name : '--'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.segmentField')}
                            inputProps={{readOnly: true}}
                            value={productCode.segment ? productCode.segment : '--'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.categoryField')}
                            value={productCode.category ? productCode.category : '--'}

                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.descriptionField')}
                            InputProps={{readOnly: true}}
                            value={productCode.description ? productCode.description : '--'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            label={t('salesmarketing:product.createForm.startDateField')}
                            value={productCode.startDate ? dayjs(productCode.startDate).format("lll") : '--'}
                            fullWidth
                            InputProps={{readOnly: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            label={t('salesmarketing:product.createForm.endDateField')}
                            value={productCode.endDate ? dayjs(productCode.endDate).format("lll") : '--'}
                            fullWidth
                            InputProps={{readOnly: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            label={t('salesmarketing:product.deposit')}
                            value={productCode.preAuthCode ? depositList.find((el : any)=> el.id === productCode.preAuthCode)?.description  : '--'}
                            fullWidth
                            InputProps={{readOnly: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.guaranteeField')}
                            value={productCode.guaranteeScheme ? productCode.guaranteeScheme : '--'}
                            InputProps={{readOnly: true}}
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.paymentMethodField')}
                            value={productCode.paymentMethod ? productCode.paymentMethod : '--'}
                            InputProps={{readOnly: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.paymentDueDateField')}
                            InputProps={{readOnly: true}}
                            value={productCode.paymentDueDate ? productCode.paymentDueDate : '--'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.billingModeField')}
                            value={productCode.billingMode ? productCode.billingMode : '--'}
                            InputProps={{readOnly: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.firstRecipientField')}
                            value={productCode.firstInvoiceRecipient ? productCode.firstInvoiceRecipient : '--'}

                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.subsequentRecipientField')}
                            value={productCode.subsequentInvoiceRecipient ? productCode.subsequentInvoiceRecipient : '--'}
                            InputProps={{readOnly: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('salesmarketing:product.createForm.paymentTimingField')}
                            value={productCode.paymentTiming ? productCode.paymentTiming : '--'}
                        />
                    </Grid>
                    {productCode.tax_configuration &&
                        <Grid item xs={12} sx={{marginTop:'50px'}}>
                            <TaxConfigurationDetail taxConfiguration={productCode.tax_configuration}/>
                        </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions style={{backgroundColor: theme.palette.neutral.main}}>
                <Button color={"accent"}
                        onClick={() => props.handleClose()}>{t('salesmarketing:product.details.close')}</Button>
            </DialogActions>
        </Dialog>
    );
}
export default ProductCodeDetailModal;